// extracted by mini-css-extract-plugin
export var menuItem = "K_xn d_fZ d_by d_bC d_bN d_bd";
export var menuItemSub = "K_xp d_Y d_by d_bN";
export var menuMainLink = "K_xq d_f0 d_dz";
export var menuLink = "K_xr d_f0 d_dz";
export var icon = "K_pD d_bB d_bN";
export var divider = "K_xs d_bB d_bN";
export var sublinks = "K_xt";
export var link = "K_mC";
export var Link = "K_vs F_vs F_tN F_t6";